
<template>
<div class="twenty" :style='twentyStyle'>
    <div class="frameHolder top-left-frame bottom-right-frame">
        <div class="managerCard lcpCard framedCard" :class="compared">
            <div class="iconRating">
                <span class="icon icon-award"><div class="rating">{{managerInfo.rating}}</div></span>
            </div>
            <div class="assetTypeCircle">
                <span class="assetInitials" v-if="managerInfo.comparison">{{positionArray[parseInt(index)]}}</span>
                <span class="assetInitials" v-else>X</span>
            </div>
            <div class="managerTitle" :title="$store.state.universe.data.keyData[managerInfo.ticker].name">{{$store.state.universe.data.keyData[managerInfo.ticker].name}}</div>
            <div class="sector">{{$store.state.universe.data.keyData[managerInfo.ticker].categories[0]}} <span class="sectorColor" :style="{backgroundColor: sectorColour}"></span></div>
            <div class="stats">
                <div class="info-row" v-for="(stat, index) in cardInfo(managerInfo.ticker)" :key="index">
					<div class="info-name">{{stat.name}}:</div>
					<div>{{stat.value}}</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

class ValueInfo {
    constructor (name, value) {
        this.name = name;
        this.value = value;
    }
}

const listOrderGeneral = [
	'Asset class',
	'Return (% - pa over 1y)',
	'Standard deviation (% pa)',
	'Max drawdown',
	'Fee',
	'LCP rating',
	'Beta to bonds',
	'Beta to equities',
	'LcpDueDilligence',
	'FundOpenOrClosed',
	'AUM',
];

const listOrderInfrastruture = [
    'Asset class',
    'Expected return (% pa)',
    'Cash yield (% pa)',
	'AUM',
	'Expected time to drawdown (months)',
    'Solvency capital ratio (estimate)',
];

export default {
    props: ['managerInfo', 'arrayIndex', 'topTrump', 'position', 'index'],
    data () {
        return {
            positionArray: ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th', '11th', '12th', '13th', '14th', '15th', '16th'],
            transition: 'all 1.0s ease-in-out',
            twentyStyle: '',
        };
    },
    methods: {
        formattedValue (value, scaling, statName) {
			let textValue = 'Unavailable';
			if (value !== null) {
				value *= scaling.scaleFactor;
				textValue = value;
				switch (statName) {
				case 'Length of track record':
					textValue = (value).toFixed(1);
					break;
				case 'AUM':
					textValue = `£${value / 1000}bn`;
					if (value / 1000 < 1) {
						textValue = `£${value}m`;
					}
					break;
				default:
					textValue = value.toFixed(scaling.decimalPlaces);
				}
				if (statName !== 'AUM') textValue = parseFloat(textValue).toLocaleString();
				scaling.prefix != null && statName !== 'AUM' ? textValue = scaling.prefix + textValue : '';
				scaling.suffix != null && statName !== 'AUM' ? textValue += scaling.suffix : '';
				statName === 'Fee' && value === 0 ? textValue = 'Price on application' : '';
			}
            return textValue;
        },
        toggleComparison () {
            this.$store.commit({ type: 'toggleManagerComparison', arrayIndex: this.managerInfo.oIndex });
        },
        removeManager () {
            this.$store.commit({ type: 'setManagerDeleted', arrayIndex: this.managerInfo.oIndex });
        },
        cardInfo (ticker) {
            const dataList = [];
            const data = this.$store.state.universe.data.keyData[ticker].values;
            const dimensions = this.$store.state.universe.data.valueDimensions;

            for (let index = 0; index < data.length; index += 1) {
                dataList.push(
                    new ValueInfo(
                        dimensions[index].name, this.formattedValue(data[index],
                            dimensions[index].valueScaling, dimensions[index].name),
                    ),
                );
            }

			const returnInfo = [];
			const listOrder = this.testType === 'General' ? listOrderGeneral : listOrderInfrastruture;
            for (let lo = 0; lo < listOrder.length; lo += 1) {
                const info = dataList.findIndex(z => z.name === listOrder[lo]);
                if (info > -1) returnInfo.push(dataList[info]);
            }
            return returnInfo;
        },
    },
    mounted () {
        this.twentyStyle = {
            '-webkit-transition': this.transition,
            '-moz-transition': this.transition,
            '-o-transition': this.transition,
            transition: this.transition,
            left: 0,
            top: 0,
        };
    },
    computed: {
        compared () {
            return this.managerInfo.comparison ? 'isCompared' : 'notCompared';
        },
        sectorColour () {
            const sectorName = this.$store.state.universe.data.keyData[this.managerInfo.ticker].categories[0];
            const sectorIndex = this.$store.state.universe.data.categoryDimensions[0].order.indexOf(sectorName);
            return this.$store.state.universe.data.categoryDimensions[0].colors[sectorIndex];
		},
		testType () {
			return this.$store.state.chart.tooltipSelection;
		},
    },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import 'src/assets/scss/all.scss';
.twenty {
    @media (max-width: 994px) {
        min-width: 50%;
    }
    float: left;
    margin-bottom: 16px;
    padding:0 10px;
    position: absolute;
    width: 25%;
    .frameHolder {
        position: relative;
        z-index: 0;
    }
    .managerCard {
        padding: 10px 26px 8px;
        position: relative;
        &.notCompared {
            background-color: #eeeeee;
            box-shadow: none!important;
        }
        .icon-star {
            color: $lightBlue!important;
            margin:3px 4px 0 0;
        }
        .iconTrash:before {
            content: '\e934';
            cursor: pointer;
            font-family: 'icomoon' !important;
            font-size: 26px;
            font-style: normal;
            font-variant: normal;
            font-weight: normal;
            line-height: 1;
            position: absolute;
            right: 20px;
            speak: none;
            text-transform: none;
            /* Better Font Rendering =========== */
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }
        .iconRating {
            position: absolute;
            left: 20px;
            .icon {
                color: $LCPGrapefruit;
                font-size: 50px;
                position: relative;
            }
            .rating {
                color: $LCPBlue;
                font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
                font-size: 16px;
                font-weight: bold;
                position:absolute;
                text-align: center;
                top: 10px;
                width: 50px;
            }
        }
        .iconCompare:before {
            cursor: pointer;
            font-family: 'icomoon' !important;
            font-size: 26px;
            font-style: normal;
            font-variant: normal;
            font-weight: normal;
            left: 20px;
            line-height: 1;
            position: absolute;
            speak: none;
            text-transform: none;
            /* Better Font Rendering =========== */
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }
        .isCompared:before {
            content: '\e90e';
        }
        .isCompared:hover:before {
            content: '\e935';
        }
        .notCompared:before {
            content: '\e937';
        }
        .notCompared:hover:before {
            content: '\e936';
        }
        .assetTypeCircle {
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
            background-color: transparent;
            border-left: 5px solid $lightBlue;
            border-radius: 30px;
            border-right: 5px solid $darkBlue;
            box-sizing: border-box;
            height: 60px;
            margin: 5px auto;
            position: relative;
            width: 60px;
            .assetInitials {
                font-size: 20px;
                position: absolute;
                text-align: center;
                top: 14px;
                width: 50px;
            }
        }
        .managerTitle {
            font-size: 14px;
            font-weight: 500;
            height: 42px;
            margin-bottom: 0px;
            margin-top: 10px;
            overflow: hidden;
            text-align: left;
            text-overflow: ellipsis;
            width: 100%;
        }
        .sector {
            font-size: 12px;
            margin-bottom: 8px;
            width: 100%;
            .sectorColor {
                border-radius:6px;
                float: right;
                height: 12px;
                margin-top: 2px;
                width:12px;
            }
        }
        .stats {
            color: $lightBlue;
            .info-row {
                border-bottom: 1px solid $lightGrey;
                margin-bottom: 3px;
                text-align: right;
                &:last-child {
                    border-bottom: none;
                }
				display: flex;
				justify-content: space-between;
                div {
                    color: $darkGrey;
                    font-weight: 500;
                }
				.info-name {
					text-align: left;
				}
            }
            .topTrump {
                background-color: $darkBlue;
                color: white;
                margin: 0 -5px;
                padding: 0 5px;
                span {
                    color: white;
                }
            }
        }
    }
}

</style>
